module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'NLRP'
        },
        {
          text: 'Partnership Program'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Partnership Program")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Partnership Program\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "id": "tryout_tambah",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createPartnership()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tambah Program\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "hasDownload": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "hasMultiSearch": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total_pages,
      "custom-pagination-total-items": _vm.total,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.detailPartnership()
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.filters = $event;
        _vm.doSearch();
      },
      "deleteOnFilter": function($event) {
        return _vm.delByOneFilter($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13603728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/partnership/components/PartnershipProgram.vue
// module id = 2190
// module chunks = 1